import { useEffect, useState } from "react";
import { DownloadCloud } from "lucide-react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { EmptyState } from "../../components/Common";
import { MEMBER_MENU } from "../../lib/menus";
import { formatDate, typeLabel } from "../../lib/format";
import api from "../../lib/api";

export default function Downloads() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    document.title = "Riwayat Download - DS KODE";
    api.get("/member/downloads").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);
  return (
    <DashboardLayout title="Riwayat Download" menu={MEMBER_MENU} testid="member-downloads">
      {rows === null ? (
        <div className="h-64 skeleton rounded-xl" />
      ) : rows.length === 0 ? (
        <EmptyState icon={DownloadCloud} title="Belum ada riwayat download." subtitle="Unduhan Anda akan tercatat di sini." />
      ) : (
        <div className="card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[500px]">
              <thead className="bg-slate-50 border-b border-slate-200"><tr><th className="th">Produk</th><th className="th">Jenis File</th><th className="th">Tanggal</th></tr></thead>
              <tbody className="divide-y divide-slate-100">
                {rows.map((r) => (
                  <tr key={r.id} data-testid={`dl-row-${r.id}`}>
                    <td className="td font-medium text-slate-900">{r.product_title}</td>
                    <td className="td">{typeLabel(r.download_type)}</td>
                    <td className="td text-slate-500">{formatDate(r.downloaded_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
